module.exports = __webpack_public_path__ + "media/images/app-download-appstore-80aad269a31b6051287bca5c26846f1a.png";